import "./styles.css";
import { Header } from "../header-new/header";
import equi from "../../asset-source/vmeste-wjet-header.png";
import chinchinpic1 from "../../asset-source/vmeste-wjet-structure-4.png";
import registration from "../../asset-source/vmeste-wjet-registration-6.png";
import rating from "../../asset-source/vmeste-wjet-design-system-5-1.jpg";
import screenshot from "../../asset-source/vmeste-wjet-app-screenshots-7.png";
import functional from "../../asset-source/vmeste-wjet-functional-screens-3-1.png";
import functional2 from "../../asset-source/vmeste-wjet-functional-screens-3-2.png";
import system2 from "../../asset-source/vmeste-wjet-design-system-5-2.jpg";

import { useState } from "react";

import { Footer } from "../footer/footer";
import checkmark from "../../asset-source/checkmark-white.png";
import checkmarkViolet from "../../asset-source/checkmark-violet.png";

import ContactUsModal from "../modal/contact-us";
import { useNavigate } from "react-router-dom";

function VmestePage() {
  const navigate = useNavigate();
  document.title = "В.месте — UX/UI дизайн приложения для встреч и общения";
  document.getElementsByTagName("META")[2].content =
    "Исследование и разработка дизайна для «В.месте» — приложения, объединяющего людей для встреч и общения. Подходы к UX/UI и создание удобного пользовательского опыта";

  document.getElementsByTagName("META")[3].content =
    "UX/UI дизайн, UX дизайн для iOS и Android, Дизайн-система для приложений, Разработка интерфейса, Дизайн мобильных приложений, Карта переходов в приложении, UX паттерны для приложений, Современный дизайн приложений";

  return (
    <div className="vmeste">
      <div className="wrapper vmeste__wrapper">
        <Header onLight={false} />

        <div className="vmeste__container">
          <div className="container">
            <a
              href="/cases"
              className="allProjectLink"
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Arrow 4"
                  d="M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM17 9H1V7H17V9Z"
                  fill="currentColor"
                />
              </svg>
              Все проекты
            </a>

            <div className="h1">
              Дизайн интерфейса «
              <span style={{ color: "rgba(166, 36, 117, 1)" }}>в.</span>
              месте»
            </div>

            <img
              src={equi}
              alt="Главный экран мобильного приложения 'В.месте' с элементами поиска встреч и навигацией"
              className="picture vmeste__headpicture"
            />
          </div>
        </div>
      </div>

      <div className="feature__wrapper section__about">
        <div className="container">
          <div className="containersm">
            <div className="about__title">
              <h1 className="about__titlerow">
                Разработка UX/UI дизайна для приложения «В.месте»
              </h1>
            </div>

            <div className="about__features">
              <div className="about__featureunit">
                <div>Бренд</div>
                <div className="about__featurevalue">Вместе</div>
              </div>

              <div className="about__featureunit">
                <div>Индустрия</div>
                <div className="about__featurevalue">
                  Dating & Networking (Знакомства и&nbsp;нетворкинг)
                </div>
              </div>

              <div className="about__featureunit">
                <div>Релиз</div>
                <div className="about__featurevalue">2024</div>
              </div>
            </div>

            <div className="abouts">
              <div className="aboutstitle">О&nbsp;проекте</div>
              <div className="about__hatinfo">
                В&nbsp;мире, где&nbsp;люди проводят большую часть жизни,
                не&nbsp;выпуская из&nbsp;рук&nbsp;смартфонов, живое общение
                становится как&nbsp;никогда ценным. В.месте&nbsp;—
                это&nbsp;мобильное приложение, которое поможет легко находить
                новых знакомых с&nbsp;общими интересами и&nbsp;организовывать
                с&nbsp;ними встречи в&nbsp;реальной жизни. Мы&nbsp;полностью
                продумали UX/UI дизайн для&nbsp;этого проекта, чтобы&nbsp;каждый
                шаг&nbsp;— от&nbsp;поиска до&nbsp;самой встречи&nbsp;—
                был&nbsp;простым, удобным и, главное, приятным.
              </div>
            </div>

            <div className="abouts">
              <div className="aboutstitle">Задача</div>
              <div className="about__hatinfo">
                <div className="numlist">
                  <div className="numlistUnit">
                    <div className="numlistNum">1.</div>
                    <div>
                      разработать сценарии для&nbsp;основного функционала
                      приложения;
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">2.</div>

                    <div>
                      продумать все&nbsp;экраны интерфейсов
                      и&nbsp;их&nbsp;состояния;
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">3.</div>

                    <div>
                      создать дизайн-систему, которая будет служить основой
                      для&nbsp;дальнейшего развития продукта.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="abouts">
              <div className="aboutstitle">Что&nbsp;мы&nbsp;сделали</div>
              <div className="about__hatinfo">
                <div className="numlist">
                  <div className="numlistUnit">
                    <img
                      src={checkmark}
                      alt=""
                      className="numlistCheck"
                    />

                    <div>
                      Создали универсальный дизайн для&nbsp;iOS
                      и&nbsp;Android&nbsp;— яркий и&nbsp;выразительный,
                      но&nbsp;без&nbsp;ухода в&nbsp;мультяшность
                      и&nbsp;детскость.
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <img
                      src={checkmark}
                      alt=""
                      className="numlistCheck"
                    />

                    <div>
                      Предусмотрели все&nbsp;возможные сценарии взаимодействия
                      для&nbsp;разных групп пользователей (и&nbsp;участников,
                      и&nbsp;организаторов встреч) и&nbsp;переходы
                      между&nbsp;страницами.
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <img
                      src={checkmark}
                      alt=""
                      className="numlistCheck"
                    />

                    <div>
                      Создали компактную дизайн-систему проекта,
                      чтобы&nbsp;минимизировать ошибки и&nbsp;неверные
                      интерпретации при&nbsp;разработке
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feature__wrapper">
        <div className="container">
          <div className="containersm">
            <div className="about__title">
              <h2 className="about__titlerow">
                Дизайн и функционал приложения
              </h2>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">
                Дизайн: поиск баланса между&nbsp;минимализмом и&nbsp;живостью
              </h3>
              <div className="about__hatinfo">
                Дизайн хотелось сделать ярким и&nbsp;выразительным,
                но&nbsp;без&nbsp;лишней мультяшности и&nbsp;детскости.
                А&nbsp;кроме того, нужно было сохранить баланс
                между&nbsp;минимализмом и&nbsp;живостью, чтобы&nbsp;приложение
                выглядело привлекательно, но&nbsp;не&nbsp;сухо.&nbsp;
                <div className="br" />
                При&nbsp;этом минимализм не&nbsp;нужно путать
                с&nbsp;банальностью&nbsp;— иногда, чтобы&nbsp;создать чистый
                и&nbsp;тщательно проработанный минималистичный дизайн, требуется
                до&nbsp;10+ итераций одного экрана, прежде чем&nbsp;появится
                финальная версия. Важно было также&nbsp;сохранить узнаваемость,
                поэтому мы&nbsp;выбрали нестандартную цветовую схему&nbsp;—
                зелёный с&nbsp;фиолетовым, чтобы&nbsp;добавить яркости
                и&nbsp;уникальности.
              </div>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">Функционал приложения </h3>
              <div className="about__hatinfo">
                Здесь нашей задачей было сделать поиск встреч по&nbsp;интересам
                максимально быстрым и&nbsp;удобным для&nbsp;пользователей,
                без&nbsp;сложных фильтров и&nbsp;настроек. Ведь&nbsp;именно
                для&nbsp;этого и&nbsp;создавался проект&nbsp;— дать
                пользователям возможность организовывать встречи с&nbsp;новыми
                знакомыми по&nbsp;интересам в&nbsp;любом городе России,
                либо&nbsp;откликаться и&nbsp;посещать организованные встречи.
              </div>
            </div>
          </div>

          <img
            src={functional}
            alt="Цветовая схема приложения 'В.месте'"
            className="about__widepic sqeezed"
          />

          <div className="containersm">
            <div className="abouts">
              <h3 className="aboutstitle">
                Требования и&nbsp;ограничения, которые определили итоговый
                дизайн и&nbsp;функционал приложения
              </h3>
              <div className="about__hatinfo">
                Их&nbsp;было несколько:
                <div className="numlist">
                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Не&nbsp;усложнять пользовательские сценарии&nbsp;— сделать
                      их&nbsp;интуитивными, удобными и&nbsp;доступными
                      даже&nbsp;для&nbsp;тех, кто&nbsp;с&nbsp;приложениями
                      на&nbsp;«вы».
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Не&nbsp;перегрузить деталями&nbsp;—
                      мы&nbsp;все&nbsp;же&nbsp;стремились к&nbsp;минимализму.
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Создать универсальный дизайн для&nbsp;iOS
                      и&nbsp;Android&nbsp;— объединить лучшие решения обеих
                      платформ, которые все&nbsp;больше сходятся по&nbsp;стилю
                      и&nbsp;подходам.
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Использовать белый фон, добившись этим максимальной
                      чистоты. Обычно для&nbsp;таких приложений активно
                      используют слоистость (градация серых фонов).
                      Мы&nbsp;же&nbsp;решили уйти от&nbsp;визуального «шума»
                      и&nbsp;«грязи».
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Максимально избегать использования теней,
                      чтобы&nbsp;визуально подчеркнуть простоту и&nbsp;лёгкость.
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Сделать сложный фильтр функциональным,
                      но&nbsp;при&nbsp;этом лёгким и&nbsp;воздушным,
                      как&nbsp;и&nbsp;форму для&nbsp;создания новых встреч.
                    </div>
                  </div>

                  <div className="numlistUnit">
                    <div className="numlistNum">
                      <img
                        src={checkmarkViolet}
                        alt=""
                        className="numlistCheck"
                      />
                    </div>
                    <div>
                      Сделать удобными обе&nbsp;роли пользователей&nbsp;—
                      и&nbsp;участника, и&nbsp;организатора встреч.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src={functional2}
            alt="Интерфейс приложения 'В.месте' для быстрого и удобного поиска встреч по интересам"
            className="about__widepic sqeezed"
          />
        </div>
      </div>

      <div className="feature__wrapper vmeste__structure">
        <div className="container">
          <div className="containersm">
            <div className="about__title">
              <div>
                <h2 className="about__titlerow">
                  Структура приложения и&nbsp;карта переходов
                </h2>

                <div className="about__hatinfo hatinfo__hatfix">
                  Одной из&nbsp;ключевых задач при&nbsp;разработке приложения
                  было предусмотреть все&nbsp;возможные сценарии и&nbsp;переходы
                  между&nbsp;страницами, чтобы&nbsp;пользователи могли легко
                  ориентироваться в&nbsp;различных ситуациях.
                </div>
              </div>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">
                Визуализация пользовательского пути в&nbsp;приложении
              </h3>
              <div className="about__hatinfo">
                Каждая встреча в&nbsp;приложении имеет несколько
                состояний&nbsp;— от&nbsp;этапа ожидания до&nbsp;публикации
                и&nbsp;начала встречи. Мы&nbsp;предусмотрели возможность
                подтверждения участия всех участников прямо в&nbsp;приложении.
                <div className="br" />
                Благодаря тщательно продуманной структуре переходов,
                пользователи легко находят нужные функции и&nbsp;могут быстро
                взаимодействовать с&nbsp;различными элементами приложения.
                Это&nbsp;значительно улучшает пользовательский опыт, поскольку
                делает приложение простым и&nbsp;удобным.
                А&nbsp;пользовательский опыт&nbsp;— это&nbsp;не&nbsp;просто
                удобство, по&nbsp;сути, он&nbsp;определяет успех продукта
                на&nbsp;рынке.
              </div>
            </div>
          </div>

          <img
            src={chinchinpic1}
            alt="Карта переходов в приложении 'В.месте', визуализирующая пользовательский путь"
            className="about__widepic sqeezed"
          />

          <div className="containersm">
            <div className="abouts">
              <h3 className="aboutstitle">
                Как&nbsp;мы&nbsp;оптимизировали навигацию и&nbsp;переходы
              </h3>
              <div className="about__hatinfo">
                <div>
                  Мы&nbsp;постарались сделать все&nbsp;переходы внутри
                  приложения простыми и&nbsp;логичными. В&nbsp;тех&nbsp;местах,
                  где&nbsp;другие приложения требуют 5–10&nbsp;шагов,
                  мы&nbsp;сократили их&nbsp;до&nbsp;2–5.
                  Так&nbsp;что&nbsp;у&nbsp;пользователя просто нет&nbsp;шансов
                  уйти далеко в&nbsp;лес&nbsp;и&nbsp;заблудиться
                  в&nbsp;приложении.
                  <div className="br" />
                  При&nbsp;этом редкие сценарии, которыми пользуются лишь 10%
                  пользователей, мы&nbsp;спрятали глубже. А&nbsp;самые
                  популярные функции вынесли на&nbsp;первый-второй уровень,
                  чтобы&nbsp;они&nbsp;всегда были на&nbsp;виду и&nbsp;легко
                  доступны.
                </div>
              </div>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">
                Как&nbsp;мы&nbsp;упрощаем путь пользователя к&nbsp;целевым
                действиям
              </h3>
              <div className="about__hatinfo">
                <div>
                  На&nbsp;всех экранах мы&nbsp;аккуратно направляем пользователя
                  к&nbsp;нужным действиям через&nbsp;активные кнопки. Там,
                  где&nbsp;выбор не&nbsp;обязателен,
                  мы&nbsp;его&nbsp;минимизировали, чтобы&nbsp;не&nbsp;загружать
                  пользователя лишними решениями. Когда приложение интуитивно
                  подсказывает правильные шаги и&nbsp;минимизирует ненужный
                  выбор, пользователи быстрее достигают целей и&nbsp;остаются
                  довольны. А&nbsp;это&nbsp;повышает вероятность того,
                  что&nbsp;они&nbsp;будут возвращаться к&nbsp;приложению
                  и&nbsp;рекомендовать&nbsp;его.
                  <div className="br" />
                  Однако любой минимализм хорош в&nbsp;меру.
                  В&nbsp;тех&nbsp;местах, где&nbsp;важно наличие множества
                  настроек, например, для&nbsp;создания мероприятий,
                  мы&nbsp;ничего не&nbsp;сокращали. Это&nbsp;позволяет
                  пользователям сохранить полный контроль над&nbsp;важными
                  параметрами и&nbsp;гибко настраивать встречи под&nbsp;свои
                  нужды.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feature__wrapper section__about section__about--designsystem">
        <div className="container">
          <div className="containersm">
            <div className="about__title">
              <div>
                <h2 className="about__titlerow">
                  Дизайн-система для приложения «В.месте»: единство
                  UI-компонентов и UX-решений
                </h2>

                <div className="about__hatinfo hatinfo__hatfix">
                  Мы создали дизайн-систему проекта полностью с нуля,
                  чтобы минимизировать ошибки и неверные интерпретации
                  при разработке. В ней нет дублирующих компонентов и стилей,
                  что упрощает процесс работы. Дизайн-система охватывает
                  не только UI kit (набор элементов вроде кнопок и полей),
                  но и UX паттерны — единые правила навигации, поведения
                  карточек, плавающих элементов и других интерфейсных решений.
                  Благодаря этому интерфейс понятный и единообразный на всех
                  уровнях, и пользователь понимает, чего ждать от приложения
                  в разных ситуациях.
                </div>
              </div>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">
                Как дизайн-система ускоряет разработку
              </h3>
              <div className="about__hatinfo">
                Дизайн-системы уже давно стали стандартом для крупных продуктов,
                потому что они помогают сохранять единый стиль и логику
                интерфейса, упрощают разработку. Главный плюс — это экономия
                времени и денег на разработку и обновления. Раньше это было
                доступно только крупным компаниям, но сейчас можно использовать
                и на небольших проектах. Внедряешь такую систему — и не нужно
                постоянно что‑то переделывать. Мы в Wjet в этом хорошо
                разбираемся, поскольку создали уже не один десяток дизайн систем
                для самых разных проектов.
              </div>
            </div>
          </div>
          <img
            src={rating}
            alt="Интерфейс приложения 'В.месте'"
            className="about__widepic sqeezed"
          />
          <div className="containersm">
            <div className="abouts">
              <h3 className="aboutstitle">
                Как избежать чрезмерной сложности при создании дизайн-систем
              </h3>
              <div className="about__hatinfo">
                Часто дизайн-системы раздувают до чрезмерной сложности,
                превращая их в неповоротливые и тяжёлые конструкции,
                обслуживание которых стоит дорого. Например, вместо 10 вариантов
                кнопок делают 50, или создают палитру из 100 цветов, а в итоге
                используют всего 5. Там, где достаточно трёх заголовков,
                добавляют 10. Всё это усложняет работу, делая систему менее
                гибкой.
                <div className="br" />
                Создание строгих паттернов в UX тоже не всегда помогает.
                Разработчики дольше читают документацию и требования,
                чем занимаются непосредственно разработкой. Поэтому создание
                дизайн систем облегчает жизнь в том числе и разработчикам.
                Дизайн-система должна экономить время, а не добавлять сложности,
                и мы знаем, как этого добиться.
              </div>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">
                Шаблоны взаимодействия пользователей в дизайн-системе
              </h3>
              <div className="about__hatinfo">
                Мы придерживаемся осознанного подхода — не усложняем простые
                вещи и делаем дизайн-системы удобными как для дизайнеров,
                так и для разработчиков. В проекте В.месте с помощью
                дизайн-системы мы смогли сделать стиль приложения единым
                и последовательным. А шаблоны взаимодействия пользователей
                применили везде, избегая кастомных разовых решений, которые
                менее предсказуемы для пользователей и которые потом сложно
                и дорого поддерживать.
              </div>
            </div>
          </div>

          <img
            src={system2}
            alt="Процесс регистрации в приложении 'В.месте'"
            className="about__widepic sqeezed"
          />
        </div>
      </div>

      <div className="feature__wrapper vmeste__features">
        <div className="container">
          <div className="containersm">
            <div className="about__title">
              <h2 className="about__titlerow">
                Уникальные фишки и особенности приложения
              </h2>
            </div>

            <div className="abouts">
              <div className="about__hatinfo">
                Одной из ключевых фич приложения стал чат — базовая социальная
                функция, которая делает общение между пользователями быстрым
                и удобным.
                <div className="br" />
                Кроме того, мы уделили особое внимание процессу регистрации,
                понимая, что это самый важный этап воронки конверсии, на котором
                часто теряется много пользователей. Чтобы минимизировать отток,
                при регистрации мы запрашиваем только номер телефона,
                а остальную информацию пользователь может заполнить позже,
                по своему желанию. Он может сразу начать искать интересные
                встречи или перейти в профиль и заполнить данные о себе, когда
                ему будет удобно. Это помогает снизить барьер для входа
                и увеличить количество активных пользователей.
              </div>
            </div>
          </div>

          <img
            src={registration}
            alt="Пример унифицированных компонентов и UX паттернов в дизайн-системе приложения 'В.месте'"
            className="about__widepic sqeezed"
          />
        </div>
      </div>

      <div className="feature__wrapper vmeste__structure vmeste__structure--bottom">
        <div className="container">
          <div className="containersm">
            <div className="about__title">
              <div>
                <h2 className="about__titlerow">
                  Сроки реализации проекта и согласования с заказчиком
                </h2>

                <div className="about__hatinfo hatinfo__hatfix">
                  Создание дизайна заняло около 2 месяцев, а весь процесс
                  разработки длился 4 месяца. В ходе работы мы регулярно
                  согласовывали ключевые этапы с заказчиком. В самом начале
                  утвердили концепцию стиля, затем на этапе проработки сценариев
                  согласовали основной пользовательский путь (UX). На финальной
                  стадии завершили согласование всего объема работ с минимальным
                  количеством правок. Нам удалось избежать излишней бюрократии и
                  долгих цепочек согласований и уложиться в согласованные сроки.
                </div>
              </div>
            </div>

            <div className="abouts">
              <h3 className="aboutstitle">Что получилось</h3>
              <div className="about__hatinfo">
                В процессе работы над проектом мы постарались соблюсти баланс —
                избегали лишних усложнений там, где это не нужно, хотя при
                разработке всегда есть соблазн добавлять всё больше деталей и
                дорабатывать в погоне за идеалом. Можно бесконечно улучшать
                детали, но наша задача была создать функциональное и удобное
                решение. И мы с этим справились. У нас получился не просто MVP,
                а полноценный продукт с широким набором функций. Приложение
                оказалось удобным и функциональным. В перспективе будем делать
                расширенный набор иллюстраций, под разные кейсы и типы
                мероприятий.
              </div>
            </div>
          </div>

          <img
            src={screenshot}
            alt="Интерфейс чата в приложении 'В.месте' для быстрого общения пользователей"
            className="about__widepic sqeezed"
          />

          <button
            className="action__button"
            onClick={() => {
              navigate(`?modal`);
            }}
          >
            Обсудить проект
          </button>
        </div>
      </div>

      <div className="footerwrapper">
        <div className="container">
          <Footer backgroundColor="transparent" />
        </div>
      </div>

      <ContactUsModal />
    </div>
  );
}

export default VmestePage;
